<template>
  <div>
    <div class="maintitle">{{title}}</div> 
    <div class="title">
      <div class="cltitle"  v-for="(index) in apTitle.length" :key="index">{{apTitle[index-1]}}</div>
    </div>
    <div v-for="(index) in data.length" :key="index">
      <table-row :dataRow="data[index-1]" :dataDisable="apCon[index-1]" :startDisplay="sDis" tCol="0" tRow="0" ></table-row>
    </div>
  </div>
</template>

<script>
import apCon from '@/utils/textbookConfig.js'
import TableRow from '@/components/common/TableRow.vue'
export default {
  props: ['title', 'data'],
  components: {
    'table-row': TableRow
  },
  data () {
    return {
      apCon: apCon.textbookSec,
      apTitle: apCon.textbookSecTitle,
      sDis: 0
    }
  }
}
</script>

<style scoped>
.maintitle {
  display: flex;
  justify-content:center;
  border:1px solid #000;
  font-family: "khmer";
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  text-align:center;
  width:360px;
  height:40px;
  line-height: 40px; /*make the text vertical middle*/
}
.title {
  display: flex;
  justify-content:center;
  border:1px solid #000;
  font-family: "khmer";
  padding: 0;
  text-align:center;
  width:360px;
  height:40px;
  line-height: 40px; /*make the text vertical middle*/
}
.cltitle {
  text-align:center;
  border:1px solid #000;
  overflow: hidden;
  font-family: "khmer";
  font-size: 12px;
  width:60px;
  height:40px;
  line-height: 40px; /*make the text vertical middle*/
}

</style>

